/* eslint-disable no-mixed-operators */
/* eslint-disable react-hooks/exhaustive-deps */
import axios from "axios";
import React, { useEffect } from "react";
import { useState } from "react";
import { useLocation } from "react-router-dom";
import Spinner from "../components/spinner";

const AddClient = ({ handleNext, handleBack, clientPreId,
    handleChangeClient,
    clientMaterData, setClientMasterData,
    statusLoan, setStatusLoan,
    firmType, setFirmType,
    noOfEmploye, setNoOfEmploye,
    typeOfServices, setTypeOfServices,
    eleConnType, setEleConnType,
    addCategory, setAddCategory,
    occupancyType, setOccupancyType,
    sollarPower, setSollarPower }) => {
    const location = useLocation();
    const projectId = localStorage.getItem('projectId')

    const [isLoading, setIsLoading] = useState(false);
    const [validFirmName, setValidFirmName] = useState('firm');
    const [validGstNum, setValidGstNum] = useState('gst');
    const [validCurrAccNum, setValidCurrAccNum] = useState('curr');
    const [validBusinessAdd, setValidBusinessAdd] = useState('bussiness');
    const [validElectricityName, setValidElectricityName] = useState('electricity');
    const [validCategory, setValidCategory] = useState('category');
    const [validOccType, setValidOccType] = useState('occ');
    const [validCity, setValidCity] = useState('city')
    const [validState, setValidState] = useState('state');
    const [validEleConnType, setValidEleConnType] = useState('conn')
    const [validTypeOfServices, setValidTypeOfServices] = useState('service')
    const [ValidNoOfEmploye, setValidNoOfEmploye] = useState('emp');
    const [validStatus, setValidStatus] = useState('status');
    const [validTypeFirm, setValidTypeFirm] = useState('typefirm')

    const validateForm = () => {
        let valid = false;
        let regex = new RegExp(/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/);
        if (clientMaterData?.nameFirm === "") {
            setValidFirmName(clientMaterData?.nameFirm);
            valid = true;
        }
        const validRegex = regex.test(clientMaterData?.gstNo)
        if (clientMaterData?.gstNo === "") {
            setValidGstNum(clientMaterData?.gstNo);
            valid = true;
        } else if (validRegex === false) {
            setValidGstNum(validRegex);
            valid = true;
        }
        if (clientMaterData?.currentAccNo === "") {
            setValidCurrAccNum(clientMaterData?.currentAccNo);
            valid = true;
        }

        if (statusLoan === '') {
            setValidStatus(statusLoan)
            valid = true
        }

        if (firmType === '') {
            setValidTypeFirm(firmType)
            valid = true
        }

        if (typeOfServices === '') {
            setValidTypeOfServices(typeOfServices)
            valid = true
        }

        if (noOfEmploye === '') {
            setValidNoOfEmploye(noOfEmploye)
            valid = true
        }

        if (clientMaterData?.businessAdd === "") {
            setValidBusinessAdd(clientMaterData?.businessAdd);
            valid = true;
        }
        if (clientMaterData?.city === "") {
            setValidCity(clientMaterData?.city);
            valid = true;
        }
        if (clientMaterData?.state === "") {
            setValidState(clientMaterData?.state);
            valid = true;
        }
        if (clientMaterData?.electricityConn === "") {
            setValidElectricityName(clientMaterData?.electricityConn);
            valid = true;
        }

        if (eleConnType === '') {
            setValidEleConnType(eleConnType);
            valid = true;
        }
        if (addCategory === "") {
            setValidCategory(addCategory);
            valid = true;
        }
        if (occupancyType === "") {
            setValidOccType(occupancyType);
            valid = true;
        }
        return valid;
    };
    const handleAddClient = async () => {
        if (!validateForm()) {
            try {
                setIsLoading(true);
                const data = {
                    nameFirm: clientMaterData?.nameFirm,
                    statusLoan: statusLoan,
                    typeFirm: firmType,
                    noOfEmploye: noOfEmploye,
                    typeOfServices: typeOfServices,
                    gstNo: clientMaterData?.gstNo,
                    currentAccNo: clientMaterData?.currentAccNo,
                    city: clientMaterData?.city,
                    state: clientMaterData?.state,
                    businessAdd: clientMaterData?.businessAdd,
                    officeAdd: clientMaterData?.officeAdd,
                    eleConnType: eleConnType,
                    electricityConn: clientMaterData?.electricityConn,
                    addCategory: addCategory,
                    occupancyType: occupancyType,
                    sollarPower: sollarPower
                }
                if (clientPreId === '' && location.state === null) {
                    const response = await axios.post(`${process.env.REACT_APP_API_URL}/create-client`, data,
                        {
                            headers: {
                                Authorization: `Bearer ${localStorage.getItem('signIn')}`
                            }
                        }
                    );
                    if (response.status === 201) {
                        localStorage.setItem('clientId', response.data.result.clientId)
                        await axios.put(`${process.env.REACT_APP_API_URL}/update-project/${projectId || location.state?.projectId}`,
                            { client_Id: location.state?.clientId || response.data.result?.clientId },
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem('signIn')}`
                                }
                            }
                        );

                        handleNext()
                    }
                } else {
                    if (clientPreId || location.state.clientId) {
                        const response = await axios.put(`${process.env.REACT_APP_API_URL}/update-client/${clientPreId || location.state.clientId}`, data,
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem('signIn')}`
                                }
                            }
                        );
                        if (response.status === 201) {
                            localStorage.setItem('clientId', response.data.result.clientId)
                            handleNext()
                        }
                    } else {
                        const response = await axios.post(`${process.env.REACT_APP_API_URL}/create-client`, data,
                            {
                                headers: {
                                    Authorization: `Bearer ${localStorage.getItem('signIn')}`
                                }
                            }
                        );
                        if (response.status === 201) {
                            localStorage.setItem('clientId', response.data.result.clientId)
                            await axios.put(`${process.env.REACT_APP_API_URL}/update-project/${projectId || location.state?.projectId}`,
                                { client_Id: location.state?.clientId || response.data.result?.clientId },
                                {
                                    headers: {
                                        Authorization: `Bearer ${localStorage.getItem('signIn')}`
                                    }
                                }
                            );
                            handleNext()
                        }
                    }
                }
            } catch (error) {
                console.error('Error submitting client data:', error);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleEditData = async () => {
        if (clientPreId !== '' || location.state && location.state.editMode === true) {
            const response = await axios.get(
                `${process.env.REACT_APP_API_URL}/get-client-byId/${clientPreId || location.state.clientId}`,
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('signIn')}`
                    }
                }
            );
            const data = response.data.result[0]

            setClientMasterData(data);
            setStatusLoan(data?.statusLoan)
            setFirmType(data?.typeFirm)
            setNoOfEmploye(data?.noOfEmploye)
            setTypeOfServices(data?.typeOfServices)
            setAddCategory(data?.addCategory)
            setEleConnType(data?.eleConnType)
            setOccupancyType(data?.occupancyType)
            setSollarPower(data?.sollarPower)
        }
    }

    useEffect(() => {
        handleEditData()
    }, [])

    return (
        <div>
            {isLoading ? (
                <Spinner />
            ) : (
                <>
                    <div className="container card card-body">
                        <form>
                            <div className='form-row'>
                                <div className='form-group col-md-6'>
                                    <label>Name of Firm</label>
                                    <input type='text'
                                        name="nameFirm"
                                        className={`form-control ${validFirmName === '' && 'is-invalid'}`}
                                        value={clientMaterData?.nameFirm || ''}
                                        onChange={e => { handleChangeClient(e); setValidFirmName(e.target.value); }}
                                    />
                                    {validFirmName === '' && (
                                        <p className="invalid-feedback">Firm name is required</p>
                                    )}
                                </div>

                                <div className='form-group col-md-6'>
                                    <label>Status of Loan</label>

                                    <select className={`custom-select mr-sm-2 ${validStatus === '' && 'is-invalid'}`}
                                        value={statusLoan || ''}
                                        onChange={e => { setStatusLoan(e.target.value); setValidStatus(e.target.value) }}
                                    >
                                        <option value=''>Select</option>
                                        <option value='sanction'>Sanction</option>
                                        <option value='disbursed'>Disbursed</option>
                                    </select>
                                    {validStatus === '' && (
                                        <p className="invalid-feedback">Status of Loan is required</p>
                                    )}
                                </div>
                            </div>

                            <div className='form-row'>
                                <div className='form-group col-md-4'>
                                    <label>Type of Firm</label>
                                    <select className={`custom-select mr-sm-2 ${validTypeFirm === '' && 'is-invalid'}`}
                                        value={firmType || ''}
                                        onChange={e => { setFirmType(e.target.value); setValidTypeFirm(e.target.value) }}
                                    >
                                        <option value=''>Select</option>
                                        <option value='proprietor'>Proprietor</option>
                                        <option value='partner'>Partner</option>
                                        <option value='corporation'>Corporation</option>
                                    </select>
                                    {validTypeFirm === '' && (
                                        <p className="invalid-feedback">Type of Firm is required</p>
                                    )}
                                </div>
                                <div className='form-group col-md-4'>
                                    <label>Number of Employee</label>
                                    <input
                                        type='number'
                                        name="nameFirm"
                                        className={`form-control ${ValidNoOfEmploye === '' && 'is-invalid'}`}
                                        value={noOfEmploye || ''}
                                        onChange={e => {
                                            setNoOfEmploye(e.target.value);
                                            setValidNoOfEmploye(e.target.value);
                                        }}
                                    />
                                    {ValidNoOfEmploye === '' && (
                                        <p className="invalid-feedback">No of Employee is required</p>
                                    )}
                                </div>
                                <div className='form-group col-md-4'>
                                    <label>Type of Services</label>
                                    <select className={`custom-select mr-sm-2  ${validTypeOfServices === '' && 'is-invalid'}`}
                                        value={typeOfServices || ''}
                                        onChange={e => {
                                            setTypeOfServices(e.target.value);
                                            setValidTypeOfServices(e.target.value);
                                        }}
                                    >
                                        <option value=''>Select</option>
                                        <option value='services'>Services Sector</option>
                                        <option value='manufacturing'>Manufacturing Sector</option>
                                    </select>
                                    {validTypeOfServices === '' && (
                                        <p className="invalid-feedback">No of Employee is required</p>
                                    )}
                                </div>
                            </div>

                            <div className='form-row'>
                                <div className='form-group col-md-6'>
                                    <label>Gst Number</label>
                                    <input type='text'
                                        name="gstNo"
                                        className={`form-control ${(validGstNum === '' || validGstNum === false) && 'is-invalid'}`}
                                        value={clientMaterData?.gstNo || ''}
                                        onChange={e => { handleChangeClient(e); setValidGstNum(e.target.value); }} />
                                    {validGstNum === '' ? (
                                        <p className="invalid-feedback">GST number is required</p>
                                    ) : <p className="invalid-feedback">Please specify a valid GSTTIN Number</p>}
                                </div>

                                <div className='form-group col-md-6'>
                                    <label>Current Account No</label>
                                    <input type='text'
                                        name="currentAccNo"
                                        className={`form-control ${validCurrAccNum === '' && 'is-invalid'}`}
                                        value={clientMaterData?.currentAccNo || ''}
                                        onChange={e => {
                                            handleChangeClient(e);
                                            setValidCurrAccNum(e.target.value);
                                        }} />
                                    {validCurrAccNum === '' && (
                                        <p className="invalid-feedback">Current account number is required</p>
                                    )}
                                </div>
                            </div>

                            <div className='form-row'>
                                <div className='form-group col-md-6'>
                                    <label>City</label>
                                    <input type='text'
                                        name="city"
                                        className={`form-control ${validCity === '' && 'is-invalid'}`}
                                        value={clientMaterData?.city || ''}
                                        onChange={e => {
                                            handleChangeClient(e);
                                            setValidCity(e.target.value);
                                        }} />
                                    {validCity === '' && (
                                        <p className="invalid-feedback">City is required</p>
                                    )}
                                </div>
                                <div className='form-group col-md-6'>
                                    <label>State</label>
                                    <input type='text'
                                        name="state"
                                        className={`form-control ${validState === '' && 'is-invalid'}`}
                                        value={clientMaterData?.state || ''}
                                        onChange={e => {
                                            handleChangeClient(e);
                                            setValidState(e.target.value);
                                        }} />
                                    {validState === '' && (
                                        <p className="invalid-feedback">State is required</p>
                                    )}
                                </div>
                            </div>

                            <div className='form-row'>
                                <div className='form-group col-md-12'>
                                    <label>Business Address</label>
                                    <input type='text'
                                        name="businessAdd"
                                        className={`form-control ${validBusinessAdd === '' && 'is-invalid'}`}
                                        value={clientMaterData?.businessAdd || ''}
                                        onChange={e => { handleChangeClient(e); setValidBusinessAdd(e.target.value); }} />
                                    {validBusinessAdd === '' && (
                                        <p className="invalid-feedback">Business address is required</p>
                                    )}
                                </div>
                            </div>

                            <div className='form-row'>
                                <div className='form-group col-md-12'>
                                    <label>Office Address</label>
                                    <input type='text'
                                        name="officeAdd"
                                        className={`form-control`}
                                        value={clientMaterData?.officeAdd || ''}
                                        onChange={e => { handleChangeClient(e); }} />
                                    {/* {validBusinessAdd === '' && (
                                        <p className="invalid-feedback">Business address is required</p>
                                    )} */}
                                </div>
                            </div>

                            <div className='form-row'>
                                <div className='form-group col-md-6'>
                                    <label>Electricity Connection Type</label>
                                    <select
                                        className={`custom-select mr-sm-2 ${validEleConnType === '' && 'is-invalid'}`}
                                        value={eleConnType || ''}
                                        onChange={e => {
                                            setEleConnType(e.target.value);
                                            setValidEleConnType(e.target.value);
                                        }}
                                    >
                                        <option value=''>Select</option>
                                        <option value='LT'>LT</option>
                                        <option value='HT'>HT</option>
                                    </select>
                                    {validEleConnType === '' && (
                                        <p className="invalid-feedback">Electricity Connection Type is required</p>
                                    )}
                                </div>
                                <div className='form-group col-md-6'>
                                    <label>Electricity Connection Name</label>
                                    <input type='text'
                                        name="electricityConn"
                                        className={`form-control ${validElectricityName === '' && 'is-invalid'}`}
                                        value={clientMaterData?.electricityConn || ''}
                                        onChange={e => { handleChangeClient(e); setValidElectricityName(e.target.value); }} />
                                    {validElectricityName === '' && (
                                        <p className="invalid-feedback">Electricity Connection name is required</p>
                                    )}
                                </div>
                            </div>

                            <div className='form-row'>
                                <div className='form-group col-md-6'>
                                    <label>Address Category</label>
                                    <select
                                        className={`custom-select mr-sm-2 ${validCategory === '' && 'is-invalid'}`}
                                        value={addCategory || ''}
                                        onChange={e => {
                                            setAddCategory(e.target.value);
                                            setValidCategory(e.target.value);
                                        }}
                                    >
                                        <option value=''>Select</option>
                                        <option value='category_1'>Category 1</option>
                                        <option value='category_2'>Category 2</option>
                                        <option value='category_3'>Category 3</option>
                                    </select>
                                    {validCategory === '' && (
                                        <p className="invalid-feedback">Address category is required</p>
                                    )}
                                </div>
                                <div className='form-group col-md-6'>
                                    <label>Occupancy Type</label>
                                    <select
                                        className={`custom-select mr-sm-2 ${validOccType === '' && 'is-invalid'}`}
                                        value={occupancyType || ''}
                                        onChange={e => {
                                            setOccupancyType(e.target.value);
                                            setValidOccType(e.target.value);
                                        }}
                                    >
                                        <option value=''>Select</option>
                                        <option value='selfowned'>Self Owned</option>
                                        <option value='rented'>Rented</option>
                                    </select>
                                    {validOccType === '' && (
                                        <p className="invalid-feedback">Occupancy is required</p>
                                    )}
                                </div>
                            </div>
                            <div className='form-row'>
                                <div className='form-group form-check col-md-12 d-flex'>
                                    <input
                                        type='checkbox'
                                        className='form-check'
                                        checked={sollarPower === 1}
                                        onChange={e => { setSollarPower(e.target.checked ? 1 : 0); }}
                                    />
                                    <label className="form-check-label fw-semibold">&nbsp;Do you have a power tariff?</label>
                                </div>
                            </div>
                            <div className='d-grid gap-2 d-md-flex justify-content-md-end'>
                                <div className='form-group text-center'>
                                    <button type='button'
                                        onClick={() => handleBack()}
                                        style={{ border: '1px solid gray', marginRight: '10px' }}
                                        className='btn btn-default btn res-btn-gray'
                                    >
                                        Previous
                                    </button>
                                    <button
                                        type='button'
                                        style={{ border: '1px solid gray' }}
                                        className='btn btn-default col-xs-offset-1'
                                        onClick={handleAddClient}
                                    >
                                        Next
                                    </button>
                                </div>
                            </div>
                        </form>
                    </div>
                </>
            )}
        </div>
    );
}

export default AddClient